{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "olenka/about",
	"version": "1.0.0",
	"title": "About Section",
	"category": "olenka-general",
	"icon": "admin-users",
	"description": "About section with portrait image and inner blocks",
	"supports": {
		"html": false
	},
	"attributes": {
		"imageUrl": {
			"type": "string",
			"default": ""
		},
		"imageId": {
			"type": "number",
			"default": 0
		},
		"imageAlt": {
			"type": "string",
			"default": ""
		},
		"imageOpacity": {
			"type": "number",
			"default": 1.0
		},
		"showBorderBottom": {
			"type": "boolean",
			"default": true
		}
	},
	"textdomain": "olenka"
}
